import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppRoutingModule } from './app-routing.module';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireModule } from '@angular/fire/compat'
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { AppComponent } from './app.component';
import { MessagingService } from './shared/messaging.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatChipsModule } from '@angular/material/chips';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { ToastrModule } from 'ngx-toastr';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { InterceptorService } from 'src/app/core/interceptor/intercept.service';
import { NgxSpinnerModule } from "ngx-spinner";
import { OAuthModule } from 'angular-oauth2-oidc';
import { OrderModule } from 'ngx-order-pipe';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GlobalErrorHandler } from 'src/app/core/services/globalErrorHandler';
import { AsyncPipe, CommonModule } from '../../node_modules/@angular/common';
import { AuthService } from "src/app/core/services/api-services/auth.service";
import { MatNativeDateModule } from '@angular/material/core';
import { CreateOrderModule } from './pages/shipping/create-order/create-order.module';
import { HealthCarePlanStatusComponent } from 'src/app/core/modals/health-care-plan-status/health-care-plan-status.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatRadioModule } from '@angular/material/radio';
import { PrescriptionStatusComponent } from 'src/app/core/modals/prescription-status/prescription-status.component';
import { TransferPrescriptionStatusComponent } from 'src/app/core/modals/prescription-status-transfer/prescription-status-transfer.component';

import { CoreModule } from 'src/app/core/core.module';
import { AddReasonPopupMultiLng } from 'src/app/core/modals/add-reason-popup-multi-lng/add-reason-popup-multi-lng.component';
import { AddReasonForPrscription } from './core/modals/add-reason-for-prscription/add-reason-for-prscription.component';
import { UpdateOrderRxidsComponent } from 'src/app/core/modals/update-order-rxids/update-order-rxids.component';
import { SharedComponentsHelperModule } from './shared-components-module/shared-components-helper.module';
import { SmokingStatusChangeComponent } from './core/modals/smoking-status-change/smoking-status-change.component';
// Get the value of 'tenant' from local storage
// const tenant = localStorage.getItem('tenant');
// // Define the Firebase configuration based on the tenant value
// let firebaseConfig :any;

// if (tenant === 'sl') {
//   firebaseConfig = environment.firebaseSunlife;
// } else if (tenant === 'qc') {
//   firebaseConfig = environment.firebaseQc;
// } else {
//   firebaseConfig = environment.firebase; // Default configuration
// }

// export function initializeFirebase(): () => Promise<void> {
//   return () => {
//     return new Promise<void>((resolve, reject) => {
//       AngularFireModule.initializeApp(firebaseConfig);
//       console.log('Firebase initialized successfully');
//       resolve();
//     });
//   };
// }


@NgModule({
  declarations: [
    AddReasonPopupMultiLng,
    AppComponent,
    PrescriptionStatusComponent,
    TransferPrescriptionStatusComponent,
    HealthCarePlanStatusComponent,
    AddReasonForPrscription,
    UpdateOrderRxidsComponent,
    SmokingStatusChangeComponent
  ],
  imports: [
    MatRadioModule,
    BrowserModule,
    CoreModule,
    MatCheckboxModule,
    MatSortModule,
    MatTableModule,
    MatSlideToggleModule,
    AngularFireModule.initializeApp(
      localStorage.getItem('tenant') == 'sl'
        ? environment.firebaseSunlife
        : localStorage.getItem('tenant') == 'qc'
        ? environment.firebaseQc
        : localStorage.getItem('tenant') == 'ml'
        ? environment.firebaseTitan
        : localStorage.getItem('tenant') == 'ml_qc'
        ? environment.firebaseTitanQc
        : localStorage.getItem('tenant') == 'pl_qc'
        ? environment.firebasePlQc
        : localStorage.getItem('tenant') == 'wylo'
        ? environment.firebaseWylo
        : environment.firebase
    ),
    //AngularFireModule.initializeApp(localStorage.getItem('tenant') == 'sl' ? environment.firebaseSunlife : localStorage.getItem('tenant') == 'qc' ? environment.firebaseQc : environment.firebase),
    //AngularFireModule.initializeApp(environment.firebaseQc,'sl-lumino-dev-qc'),
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireDatabaseModule,
    AngularFireMessagingModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    MatMenuModule,
    MatTabsModule,
    MatTooltipModule,
    MatChipsModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    NgxPaginationModule,
    MatDatepickerModule,
    MatSelectModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    CreateOrderModule,
    SharedComponentsHelperModule,
    CommonModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-bottom-left',
      preventDuplicates: true,
    }),
    NgxSpinnerModule,
    OAuthModule.forRoot(),
    OrderModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [AuthService, AsyncPipe, MessagingService,
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
